export enum AuthEnum {
  SIGN_IN = 0,
  NEW_PASSWORD_REQUIRED = 1,
  ACCOUNT_CREATED = 2,
  NOTIFICATION_PREFERENCES = 3,
  FORGOT_PASSWORD = 4
}
